export default __webpack_public_path__ + "static/media/credit_icon_unlocked.b1d69859.png";